var _defs, _rect, _path, _polygon, _rect2, _path2, _path3, _rect3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#346dec;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.16,
    y: 10.71,
    width: 3.34,
    height: 1.92
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.44,21.12h5.43V15.69H23.44Zm1.7-3.73h2.08v2.08H25.14Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "26.39 10.71 26.39 12.65 30.05 12.65 30.05 29.06 9.95 29.06 9.95 12.65 13.19 12.65 13.19 10.71 8.01 10.71 8.01 31 31.99 31 31.99 10.71 26.39 10.71"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.16,
    y: 9,
    width: 1.92,
    height: 4.84
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.6,15.69H11.17v5.43H16.6ZM15,19.47H12.87V17.39H15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.75,27.34V21.91H17.31v5.43h5.44Zm-1.66-1.65H19V23.61h2.09Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.74,
    y: 9,
    width: 1.92,
    height: 4.84
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.16,27.34H16.6V21.91H11.16Zm1.7-3.73H15v2.08H12.86Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.75,21.12V15.69H17.31v5.43h5.44Zm-1.66-1.65H19V17.39h2.09Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/CalenderIcon.aad0213a2d2eedc085fbb3f73a7c36bb.svg";
export { ForwardRef as ReactComponent };